import React from 'react';
import { observer } from 'mobx-react';
import HolidayBottomLeftIcon from 'shared/components/HolidayThemedIcons/HolidayBottomLeftIcon';
import SidebarContent from './SidebarContent';

import classes from './Sidebar.module.scss';
import { Themes } from 'app/contexts/Brand/enums';

const Sidebar = ({ childProps }) => {
  const currUserTheme = childProps.usersStore.getCurrDisplayedUserTheme();
  return (
    <div className={classes.root}>
      <SidebarContent usersStore={childProps.usersStore} appStore={childProps.appStore} />
      {currUserTheme === Themes.Default ? (
        <HolidayBottomLeftIcon holiday={childProps.usersStore.currentHoliday} />
      ) : null}
    </div>
  );
};


const ObserverSidebar = observer(Sidebar);
export default ObserverSidebar;
